export default function delayedFade (element) {
    const baseDelaySettings = {
        delay: 300,
        className: 'fade-in',
    };

    const customDelaySettings = element.dataset.delaySettings ? JSON.parse(element.dataset.delaySettings) : {};

    const delaySettings = { ...baseDelaySettings, ...customDelaySettings };

    function init () {
        setTimeout(() => {
            element.classList.add(delaySettings.className);
        }, delaySettings.delay);
    }

    init();
}
